// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--1CQha","containerBody":"containerBody--3AQ6X","searchContent":"searchContent--2-xtx","actionButtons":"actionButtons--2XTAo"};